import { removeFilters } from '@/redux/query/utils';

export default () => (state, { payload: keys }) => removeFilters(state, keys);
